export default function(){
	(function($) {

		// Features
		var $hidden_features = $(".single-product__features--hidden")
		var $show_all_button = $(".single-product__features_show_more")
		function show_all_features(){
			$hidden_features.slideDown(300)
			$show_all_button.fadeOut(300)
		}
		$(".show-all-features").click(show_all_features)

	})(jQuery);
}
